export interface CBrewData {
  token?: string | null;
  // userName?: string | null;
  // clientID?: number | null;
  // sessionId?: string | null;
  // staffId?: number | null;
}

export const updateCBrew = (data: Partial<CBrewData>) => {
  const existing = JSON.parse(localStorage.getItem("cBrew") || "{}");

  const updated: CBrewData = {
    ...existing,
    ...data, 
  };

  localStorage.setItem("cBrew", JSON.stringify(updated));
};